import BigNumber from 'bignumber.js';
import BN from 'bn.js';
import { common } from './common';
export const JSONHelper = {
    writeUInt64LE: (value) => value.toString(16, 16),
    readUInt64LE: (value) => new BN(value, 16),
    writeUInt64: (value) => value.toString(10),
    readUInt64: (value) => new BigNumber(value),
    writeUInt160: (value) => common.uInt160ToString(value),
    readUInt160: (hash) => common.stringToUInt160(hash),
    writeUInt256: (value) => common.uInt256ToString(value),
    readUInt256: (hash) => common.stringToUInt256(hash),
    writeFixed8: (value) => common.fixed8ToDecimal(value).toString(),
    readFixed8: (value) => common.fixed8FromDecimal(new BigNumber(value)),
    writeECPoint: (value) => common.ecPointToString(value),
    readECPoint: (value) => common.stringToECPoint(value),
    writeBuffer: (value) => value.toString('hex'),
    readBuffer: (value) => Buffer.from(value, 'hex'),
};

//# sourceMappingURL=JSONHelper.js.map
